export default __webpack_public_path__ + "static/media/time.d7cbdeab.svg";